module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO39AnalizePresupuesto.cdef49b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO39AnalizePresupuesto.mp4
// module id = 765
// module chunks = 1